"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var analytics_1 = tslib_1.__importDefault(require("analytics"));
var catalytic_1 = tslib_1.__importDefault(require("./plugins/catalytic"));
function createAnalytics(config) {
    var app = config.app, version = config.version, catalyticConfig = config.catalyticConfig;
    var plugins = [];
    if (catalyticConfig) {
        plugins.push(catalytic_1.default(catalyticConfig));
    }
    return analytics_1.default({
        app: app,
        plugins: plugins,
        version: version
    });
}
exports.default = createAnalytics;
//# sourceMappingURL=client.js.map